module.exports = __webpack_public_path__ + "img/图1-3  自然语言处理.666c589e.png";